import { render } from "./RequestPage.vue?vue&type=template&id=014d5827&scoped=true"
import script from "./RequestPage.vue?vue&type=script&lang=js"
export * from "./RequestPage.vue?vue&type=script&lang=js"

import "./RequestPage.vue?vue&type=style&index=0&id=014d5827&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014d5827"]])

export default __exports__